import Api from '@api/xiu_yan/marketingToolsApi'
import mainStore from '@components/Main/store'
import { SHOP_PRODUCTS_PATH_A } from '@constant'
import { isProfessional, isUltimate } from '@merchant-backend/util'
import { getProTitle } from '@util'
import { message } from 'hljd'
import { action, observable, runInAction } from 'mobx'

class Store {
  @observable group = []
  @observable group_count = 0
  @observable group_list = []

  @observable recommend = []
  @observable recommend_count = 0
  @observable recommend_list = []

  @observable hotTop = []
  @observable hotTop_count = 0
  @observable hotTop_list = []

  @observable cheap = []
  @observable cheap_count = 0
  @observable cheap_list = []

  @observable addImgshow = false

  @action
  getTagList = async () => {
    let {
      success,
      RetCode,
      data: {
        rec,
        rec_count,
        top,
        top_count,
        cheap,
        cheap_count,
        group,
        group_count
      }
    } = await Api.market()

    runInAction(() => {
      if (success) {
        this.group = group || []
        this.group_count = group_count

        let _group_list = []
        this.group.forEach(({ id }) => {
          _group_list.push(id)
        })
        this.group_list = _group_list

        this.recommend = rec || []
        this.recommend_count = rec_count

        let _recommend_list = []
        this.recommend.forEach(({ id }) => {
          _recommend_list.push(id)
        })
        this.recommend_list = _recommend_list

        this.hotTop = top || []
        this.hotTop_count = top_count

        let _hotTop_list = []
        this.hotTop.forEach(({ id }) => {
          _hotTop_list.push(id)
        })
        this.hotTop_list = _hotTop_list

        this.cheap = cheap || []
        this.cheap_count = cheap_count

        let _cheap_list = []
        this.cheap.forEach(({ id }) => {
          _cheap_list.push(id)
        })
        this.cheap_list = _cheap_list
      } else if (RetCode == 1) {
        this.addImgshow = true
      }
    })
  }

  @action
  delTag = (value, index) => async () => {
    let params = {
      setmeal_ids: value,
      type: 'delete',
      hot_tag: index
    }

    let { success } = await Api.tag(params)
    if (success) {
      message.success('操作成功！')
      this.recommend_list = []
      this.hotTop_list = []
      this.cheap_list = []
      this.group_list = []
      this.getTagList()
    }
  }

  @observable
  proModal = {
    type: 2,
    isShow: false,
    content: '',
    btn1: '',
    btn2: '',
    hrefVal: ''
  }

  @observable
  gradeModal = {
    type: 2,
    isShow: false,
    content: '',
    btn1: '',
    btn2: '',
    hrefVal: ''
  }

  @action
  checkMerchant = value => () => {
    if (mainStore.merchantInfo.is_special_merchant != 2) {
      if (!isUltimate() && !isProfessional()) {
        this.proModal = {
          type: 2,
          isShow: true,
          content: `无法使用此功能，请升级至${getProTitle()}！`,
          btn1: '关闭',
          btn2: '了解详情',
          hrefVal: SHOP_PRODUCTS_PATH_A
        }
      } else {
        this.doTagList(value)
      }
    }
  }

  @action
  onCancelPro = () => {
    this.proModal.isShow = false
  }

  @action
  onCancelGrade = () => {
    this.gradeModal.isShow = false
  }

  @action
  doTagList = value => {
    const {
      recommend_list,
      hotTop_list,
      cheap_list,
      group_list,
      recommend_count,
      hotTop_count,
      cheap_count,
      group_count
    } = this

    let query = ''
    let count = 0
    if (value == 1) {
      query = recommend_list.join()
      count = recommend_count
    } else if (value == 2) {
      query = hotTop_list.join()
      count = hotTop_count
    } else if (value == 3) {
      query = cheap_list.join()
      count = cheap_count
    } else {
      query = group_list.join()
      count = group_count
    }

    window.location.href =
      '#/localMerchant/marketingTools/tagList/' +
      value +
      '?ids=' +
      query +
      '&count=' +
      count
  }
}

export default new Store()
